<template>
  <div class="upload-wrapper">
    <h1 class="title mb-5">Upload de arquivos</h1>
    <v-alert
      dense
      text
      v-if="alert"
      :type="alertType"
    >
      {{ alertText }}
    </v-alert>

    <v-form>
      <v-file-input
        chips
        counter
        multiple
        label="Clique para escolher arquivos"
        truncate-length="30"
        :disabled="!readyToReceiveFiles"
        v-model="chosenFiles"
      ></v-file-input>
      <v-btn
        color="accent"
        outlined
        :disabled="!readyToUpload"
        @click.prevent="sendFiles"
      >
        Enviar
      </v-btn>
    </v-form>

    <v-simple-table v-if="showList">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Arquivo</th>
            <th class="text-left">Tipo</th>
            <th class="text-left">Tamanho (MB)</th>
            <th class="text-left">Status</th>
            <th class="text-left">Progresso</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="upload in uploadList" :key="upload.name">
            <td>{{ upload.name }}</td>
            <td>{{ upload.type }}</td>
            <td>{{ upload.size }}</td>
            <td>{{ upload.status }}</td>
            <td>
              <v-progress-linear
                color="accent"
                height="10"
                :value="upload.progress * 100"
                striped
              />
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

  </div>
</template>

<script>
const Evaporate = require('evaporate')
const crypto = require('crypto')
const AWS = require('aws-sdk')
import {PROJECT_URL, AWS_KEY, AWS_BUCKET} from "./../../globals"

const uploader = Evaporate.create({
  signerUrl: PROJECT_URL + '/projects/get-presigned-url/',
  aws_key: AWS_KEY,
  bucket: AWS_BUCKET,
  computeContentMd5: true,
  maxFileSize: 100000000000,
  cryptoHexEncodedHash256: function (data) { return crypto.createHash('sha256').update(data).digest('hex'); },
  cryptoMd5Method: function (data) { return AWS.util.crypto.md5(data, 'base64') }
})

export default {
  props: ['uploadPath'],
  data(){
    return {
      chosenFiles: [],
      uploadList: [],
      showList: false,
      readyToReceiveFiles: true,
      readyToUpload: false,
      alertType: 'success',
      alert: false,
      alertText: '',
      ongoingStatus: 'Em andamento'
    }
  },
  watch: {
    chosenFiles() {
      if (this.chosenFiles.length) {
        this.readyToUpload = true
      } else {
        this.readyToUpload = false
      }
    }
  },
  methods: {
    sendFiles() {
      if (!this.chosenFiles.length) { return }
      this.alert = false
      this.readyToReceiveFiles = false
      this.readyToUpload = false
      this.uploadList = []
      this.showList = true
      this.chosenFiles.forEach((file) => {
        this.uploadList.push({
          name: file.name,
          type: file.type,
          size: (file.size / 1000000).toFixed(2),
          progress: 0,
          status: this.ongoingStatus
        })
        uploader.then((evaporate) => {
          evaporate.add({
            file,
            name: this.uploadPath + file.name,
            progress: (progressValue) => this.updateProgress(progressValue, file.name),
            complete: () => this.updateStatus(file.name, 'OK'),
            error: () => this.updateStatus(file.name, 'ERRO'),
          }).then(
            (awsObjectKey) => console.log('Success! ', awsObjectKey),
            (reason) => this.uploadFeedback('error', reason)
          );
        })
      })
    },
    updateProgress(progress, filename){
      const index = this.uploadList.findIndex(x => x.name === filename)
      this.uploadList[index].progress =  progress
    },
    updateStatus(filename, status){
      const index = this.uploadList.findIndex(x => x.name === filename)
      this.uploadList[index].status =  status
      if (status === 'OK') {
        if (!this.uploadList.filter(x => x.status === this.ongoingStatus).length) {
          this.uploadFeedback('success')
        }
      }
    },
    uploadFeedback(type, reason='') {
      this.readyToUpload = true
      this.readyToReceiveFiles = true
      this.chosenFiles = []
      this.alert = true
      this.alertType = type
      if (type == 'success') {
        this.alertText = 'Arquivos carregados com sucesso em: ' + this.uploadPath
      } else {
        this.alertText = 'Houve um erro no upload: ' + reason
      }
    }
  }
}
</script>

<style scoped>
  .title {color: #005378}
  .upload-wrapper {width: 100%}
</style>